
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_1isms_66",
  "button": "awsui_button_vjswe_1isms_70",
  "variant-normal": "awsui_variant-normal_vjswe_1isms_132",
  "disabled": "awsui_disabled_vjswe_1isms_150",
  "variant-primary": "awsui_variant-primary_vjswe_1isms_157",
  "variant-link": "awsui_variant-link_vjswe_1isms_182",
  "variant-icon": "awsui_variant-icon_vjswe_1isms_207",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_1isms_232",
  "variant-inline-icon-pointer-target": "awsui_variant-inline-icon-pointer-target_vjswe_1isms_257",
  "variant-inline-link": "awsui_variant-inline-link_vjswe_1isms_282",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_1isms_311",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_1isms_336",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_1isms_361",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_1isms_391",
  "grouped": "awsui_grouped_vjswe_1isms_416",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_vjswe_1isms_425",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_vjswe_1isms_429",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_vjswe_1isms_435",
  "grouped-vertical-first": "awsui_grouped-vertical-first_vjswe_1isms_439",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_vjswe_1isms_443",
  "grouped-vertical-last": "awsui_grouped-vertical-last_vjswe_1isms_449",
  "grouped-end-action-horizontal-last": "awsui_grouped-end-action-horizontal-last_vjswe_1isms_453",
  "grouped-end-action-horizontal-only": "awsui_grouped-end-action-horizontal-only_vjswe_1isms_453",
  "grouped-end-action-vertical-first": "awsui_grouped-end-action-vertical-first_vjswe_1isms_457",
  "grouped-end-action-vertical-last": "awsui_grouped-end-action-vertical-last_vjswe_1isms_457",
  "grouped-end-action-vertical-only": "awsui_grouped-end-action-vertical-only_vjswe_1isms_457",
  "button-no-text": "awsui_button-no-text_vjswe_1isms_546",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_1isms_550",
  "full-width": "awsui_full-width_vjswe_1isms_553",
  "button-compact": "awsui_button-compact_vjswe_1isms_570",
  "icon-left": "awsui_icon-left_vjswe_1isms_580",
  "icon-right": "awsui_icon-right_vjswe_1isms_585",
  "icon": "awsui_icon_vjswe_1isms_580",
  "link": "awsui_link_vjswe_1isms_604",
  "disabled-with-reason": "awsui_disabled-with-reason_vjswe_1isms_604"
};
  